import { Spin } from 'antd'

import { TTS_FORM_VOICE_DISPLAY_COUNT } from '../../_constant'

import VoiceCard from './VoiceCard'

import type { VoiceItem } from '../../_types/form'


import { cls } from 'tagged-classnames-free';
interface VoiceGridProps {
  voices: VoiceItem[]
  selectedVoiceId: string
  onSelect: (voice: VoiceItem) => void
  loading?: boolean
  currentPlayingId?: string | null
  currentSourceId?: string | null
  sourceId: string
  isPlaying?: boolean
  playLoading?: boolean
  onTogglePlay?: (voice: VoiceItem) => void
}

function VoiceGrid(props: VoiceGridProps) {
  const {
    voices,
    selectedVoiceId,
    onSelect,
    loading = false,
    currentPlayingId,
    currentSourceId,
    sourceId,
    isPlaying = false,
    playLoading = false,
    onTogglePlay,
  } = props

  const displayVoices = voices.slice(0, TTS_FORM_VOICE_DISPLAY_COUNT)
  const isActiveSource = currentSourceId === sourceId

  return (
    <Spin spinning={loading}>
      <div
        className={cls`grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-2`}
      >
        {displayVoices.map((voice) => (
          <VoiceCard
            key={voice.id}
            voice={voice}
            selected={selectedVoiceId === voice.id}
            playing={
              isActiveSource && currentPlayingId === voice.id && isPlaying
            }
            loading={
              isActiveSource && currentPlayingId === voice.id && playLoading
            }
            onSelect={() => onSelect(voice)}
            onTogglePlay={() => onTogglePlay?.(voice)}
            compact
          />
        ))}
      </div>
    </Spin>
  )
}

export default VoiceGrid
